<!-- layouts/TabsLayout.vue -->
<template>
  <div class="tabs-layout">
    <!-- 标签栏 -->
    <el-tabs
        v-model="activeTab"
        type="card"
        closable
        @tab-click="handleTabClick"
        @tab-remove="handleTabRemove"
    >
      <el-tab-pane
          v-for="item in visitedViews"
          :key="item.path"
          :label="item.title"
          :name="item.path"
      />
    </el-tabs>

    <!-- 内容区域：使用 keep-alive 缓存组件，include 指定需要缓存的组件名称 -->
    <div class="tabs-content">
      <keep-alive :include="cachedViews">
        <router-view :key="$route.fullPath" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'TabsLayout',
  computed: {
    ...mapState('tabs', ['visitedViews', 'currentView']),
    activeTab: {
      get() { return this.currentView },
      set(val) { this.setCurrentView(val) }
    },
    cachedViews() {
      return this.visitedViews.map(v => v.name).filter(Boolean)
    }
  },
  watch: {
    $route: {
      handler(route) {
        let title = route.meta.title
        if (typeof title === 'function') {
          if(route.params.id != '0'){
            title = title(route)
          }else{
            title = route.meta.title2
          }
        }
        // 注意：这里调用的是映射后的 addView 方法，内部实际触发 'ADD_VIEW' mutation
        this.addView({
          path: route.fullPath,
          name: route.name,
          // title: route.meta.title || '未命名'
          title: title || '未命名'
        })
        this.setCurrentView(route.fullPath)
      },
      immediate: true
    }
  },
  methods: {
    // ✅ 使用对象形式映射，将方法名与 mutation 名对应
    ...mapMutations('tabs', {
      addView: 'ADD_VIEW',
      removeView: 'REMOVE_VIEW',
      setCurrentView: 'SET_CURRENT_VIEW',
      closeOthers: 'CLOSE_OTHERS',
      closeAll: 'CLOSE_ALL'
    }),
    handleTabClick(tab) {
      const path = tab.paneName
      if (path !== this.$route.fullPath) {
        this.$router.push(path)
      }
    },
    handleTabRemove(path) {
      if (path === this.activeTab) {
        const index = this.visitedViews.findIndex(v => v.path === path)
        const prev = this.visitedViews[index - 1]
        const next = this.visitedViews[index + 1]
        const targetPath = prev?.path || next?.path || '/'
        this.$router.push(targetPath)
      }
      this.removeView(path)   // ✅ 调用映射后的 removeView
    }
  }
}
</script>

<style scoped>
.tabs-layout {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.tabs-content {
  flex: 1;
  overflow: auto;
  padding: 20px;
}
</style>